import { Action, Reducer } from "redux";
import { AppThunkAction } from ".";
import { ExecuteAction1, LineHandlingSVLModel, SVLModel } from "../models";
import {
  OfflineActivityLog,
  OfflineWorkPacketLog
} from "../models/OfflineDataHistory";
import { WorkPacketValue2 } from "../models/WorkPacket";

export interface OfflineDataState {
  offlineData: OfflineActivityLog[];
  offlineSVLData: LineHandlingSVLModel[];
  offlineWorkPacketData: OfflineWorkPacketLog[];
}

export const defaultState = {
  offlineData: [],
  offlineSVLData: [],
  offlineWorkPacketData: []
};

export interface UpdateOfflineDataAction {
  type: "UPDATE_OFFLINE_DATA";
  payload: OfflineActivityLog[];
}

export interface UpdateSVLOfflineDataAction {
  type: "UPDATE_SVL_OFFLINE_DATE";
  payload: LineHandlingSVLModel[];
}

export interface UpdateOfflineWorkPacketDataAction {
  type: "UPDATE_OFFLINE_WORK_PACKET_DATA";
  payload: OfflineWorkPacketLog[];
}

type KnownAction =
  | UpdateOfflineDataAction
  | UpdateSVLOfflineDataAction
  | UpdateOfflineWorkPacketDataAction;

export const actionCreators = {
  insertOfflineData:
    (
      lineHandlingNo: string,
      action: ExecuteAction1
    ): AppThunkAction<UpdateOfflineDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        let offlineDataList = state.offlineData.offlineData;
        if (offlineDataList && offlineDataList.length > 0) {
          const lineHandlingData = offlineDataList.find(
            (f) =>
              f.lineHandlingNo.toLowerCase() === lineHandlingNo.toLowerCase()
          );
          if (lineHandlingData) {
            offlineDataList = [
              ...offlineDataList.filter(
                (f) =>
                  f.lineHandlingNo.toLowerCase() !==
                  lineHandlingNo.toLowerCase()
              ),
              {
                lineHandlingNo,
                actions: [...lineHandlingData.actions, action]
              }
            ];
          } else {
            offlineDataList = [
              ...offlineDataList,
              { lineHandlingNo, actions: [action] }
            ];
          }
        } else {
          offlineDataList = [{ lineHandlingNo, actions: [action] }];
        }

        dispatch({
          type: "UPDATE_OFFLINE_DATA",
          payload: offlineDataList
        } as UpdateOfflineDataAction);
      }
    },
  updateOfflineData:
    (
      offlineData: OfflineActivityLog
    ): AppThunkAction<UpdateOfflineDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        let payload = state.offlineData.offlineData;
        const lineHandlingData = payload.find(
          (f) =>
            f.lineHandlingNo.toLowerCase() ===
            offlineData.lineHandlingNo.toLowerCase()
        );
        if (lineHandlingData) {
          payload = [
            ...payload.filter(
              (f) =>
                f.lineHandlingNo.toLowerCase() !==
                lineHandlingData.lineHandlingNo.toLowerCase()
            ),
            offlineData
          ];
        } else {
          payload = [...payload, offlineData];
        }

        dispatch({
          type: "UPDATE_OFFLINE_DATA",
          payload
        } as UpdateOfflineDataAction);
      }
    },
  removeOfflineData:
    (lineHandlingNo: string): AppThunkAction<UpdateOfflineDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        let payload = state.offlineData.offlineData;
        payload = [
          ...payload.filter(
            (f) =>
              f.lineHandlingNo.toLowerCase() !== lineHandlingNo.toLowerCase()
          )
        ];
        dispatch({
          type: "UPDATE_OFFLINE_DATA",
          payload
        } as UpdateOfflineDataAction);
      }
    },
  insertSVLOfflineData:
    (
      lineHandlingNo: string,
      nominations: SVLModel[]
    ): AppThunkAction<UpdateSVLOfflineDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        if (
          state.offlineData.offlineSVLData === undefined ||
          state.offlineData.offlineSVLData.length === 0
        ) {
          dispatch({
            type: "UPDATE_SVL_OFFLINE_DATE",
            payload: [
              {
                lineHandlingNo,
                nominations
              }
            ]
          } as UpdateSVLOfflineDataAction);
        } else {
          dispatch({
            type: "UPDATE_SVL_OFFLINE_DATE",
            payload: [
              ...state.offlineData.offlineSVLData,
              {
                lineHandlingNo,
                nominations
              }
            ]
          } as UpdateSVLOfflineDataAction);
        }
      }
    },
  removeSVLOfflineData:
    (lineHandlingNo: string): AppThunkAction<UpdateSVLOfflineDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        let payload = state.offlineData.offlineSVLData;
        payload = [
          ...payload.filter(
            (f) =>
              f.lineHandlingNo.toLowerCase() !== lineHandlingNo.toLowerCase()
          )
        ];
        dispatch({
          type: "UPDATE_SVL_OFFLINE_DATE",
          payload
        } as UpdateSVLOfflineDataAction);
      }
    },
  insertOfflineWorkPacketData:
    (payload: any): AppThunkAction<UpdateOfflineWorkPacketDataAction> =>
    (dispatch, getState) => {
      const state = getState();
      if (state && state.offlineData) {
        let offlineWorkPacketDataList = state.offlineData.offlineWorkPacketData;
        if (offlineWorkPacketDataList && offlineWorkPacketDataList.length > 0) {
          const lineHandlingWorkPacketData = offlineWorkPacketDataList.find(
            (f) =>
              f.lineHandlingNo.toLowerCase() ===
                payload.lineHandlingNo.toLowerCase() &&
              f.workPacketId === payload.workPacketId
          );

          if (lineHandlingWorkPacketData) {
            offlineWorkPacketDataList = [
              ...offlineWorkPacketDataList.filter(
                (f) =>
                  f.lineHandlingNo.toLowerCase() ===
                    payload.lineHandlingNo.toLowerCase() &&
                  f.workPacketId !== payload.workPacketId
              ),
              payload
            ];
          } else {
            offlineWorkPacketDataList = [...offlineWorkPacketDataList, payload];
          }
        } else {
          offlineWorkPacketDataList = [payload];
        }
        dispatch({
          type: "UPDATE_OFFLINE_WORK_PACKET_DATA",
          payload: offlineWorkPacketDataList
        } as UpdateOfflineWorkPacketDataAction);
      }
    },
  removeOfflineWorkPacketData:
    (
      lineHandlingNo: string,
      workPacketId: number
    ): AppThunkAction<UpdateOfflineWorkPacketDataAction> =>
    (dispatch, getState) => {
      const state = getState();

      if (state && state.offlineData) {
        let payload = state.offlineData.offlineWorkPacketData;
        payload = [
          ...payload.filter(
            (f) =>
              f.lineHandlingNo.toLowerCase() !== lineHandlingNo.toLowerCase() &&
              f.workPacketId !== workPacketId
          )
        ];
        dispatch({
          type: "UPDATE_OFFLINE_WORK_PACKET_DATA",
          payload: []
        } as UpdateOfflineWorkPacketDataAction);
      }
    }
};

export const reducer: Reducer<OfflineDataState> = (
  state: OfflineDataState | undefined,
  incomingAction: Action
): OfflineDataState => {
  if (state === undefined) {
    return { offlineData: [], offlineSVLData: [], offlineWorkPacketData: [] };
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "UPDATE_OFFLINE_DATA":
      return { ...state, offlineData: action.payload };
    case "UPDATE_SVL_OFFLINE_DATE":
      return { ...state, offlineSVLData: action.payload };
    case "UPDATE_OFFLINE_WORK_PACKET_DATA":
      return { ...state, offlineWorkPacketData: action.payload };
    default:
      return state;
  }
};
